const UserIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16.996 17.998">
            <g id="Group_8386" data-name="Group 8386" transform="translate(-1238.145 -1221.715)">
                <path
                    id="Path"
                    d="M19.329,18.5v-2a4,4,0,0,0-4-4h-8a4,4,0,0,0-4,4v2"
                    transform="translate(1235.312 1220.715)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <circle
                    id="Path-2"
                    data-name="Path"
                    cx="4.002"
                    cy="4.002"
                    r="4.002"
                    transform="translate(1242.641 1222.215)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default UserIcon;
